import { Box, Typography, Switch } from "@mui/material";

interface TemplateFormHeaderProps {
  templateDescription: string;
  useDataValidator: boolean;
  isSaving: boolean;
  onToggleValidator: (checked: boolean) => void;
}

const TemplateFormHeader = ({
  templateDescription,
  useDataValidator,
  isSaving,
  onToggleValidator,
}: TemplateFormHeaderProps) => {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        mb: 2,
        pb: 2,
        borderBottom: 1,
        borderColor: "divider",
      }}
    >
      <Typography variant="h6" fontWeight={600}>
        {templateDescription}
      </Typography>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1.5,
        }}
      >
        <Typography
          variant="body2"
          fontWeight={500}
          sx={{
            color: useDataValidator ? "success.main" : "text.secondary",
          }}
        >
          {useDataValidator
            ? "Used in data validator"
            : "Not used in data validator"}
        </Typography>
        <Switch
          checked={useDataValidator}
          onChange={(e) => onToggleValidator(e.target.checked)}
          disabled={isSaving}
          color="success"
          size="small"
        />
      </Box>
    </Box>
  );
};

export default TemplateFormHeader;
